import { render, staticRenderFns } from "./LikertTypeQuestion.vue?vue&type=template&id=4ab2ee7a&scoped=true&"
import script from "./LikertTypeQuestion.vue?vue&type=script&lang=js&"
export * from "./LikertTypeQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LikertTypeQuestion.vue?vue&type=style&index=0&id=4ab2ee7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab2ee7a",
  null
  
)

export default component.exports